export default {
  unprocessedData: '还有未处理的记录',
  pls_select: '请选择',
  pls_input: '请输入',
  pls_input_name_pinyin: '请输入姓名拼音',
  max: '申请金额不得大于账户余额',
  min: '申请金额不得小于0',
  correctAmount: '请输入正确的金额',
  doSuccess: '操作成功',
  doError: '更新失败，请联系客服人员',
  otherAccount: {
    getApplyRecordError: '获取申请记录出错，请联系客服',
    applyTradeAccountTypeListError: '获取申请账户信息出错，请联系客服'
  }
}
